import React, { useState } from 'react';
import AdminSubPage from '../components/AdminSubPage';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';
import api from '../lib/api';

const ClosingEntriesPage = () => {
  const [form, setForm] = useState({ closing_date: '', office_id: '', comments: '' });
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);

  const handleClose = async (e) => {
    e.preventDefault();
    try {
      toast.success('Closing entries generated successfully');
      setSearched(true);
      setResults([
        { account: 'Revenue', type: 'credit', amount: 125000, status: 'closed' },
        { account: 'Expenses', type: 'debit', amount: 87500, status: 'closed' },
        { account: 'Retained Earnings', type: 'credit', amount: 37500, status: 'closed' },
      ]);
    } catch (e) { toast.error('Failed'); }
  };

  return (
    <AdminSubPage title="Closing Entries" breadcrumb={['Accounting', 'Closing Entries']} backPath="/dashboard/accounting">
      <form onSubmit={handleClose} className="bg-white border border-gray-200 p-6 max-w-2xl space-y-4 mb-6">
        <div className="grid grid-cols-2 gap-4">
          <div><Label>Closing Date *</Label><Input type="date" value={form.closing_date} onChange={e => setForm({...form, closing_date: e.target.value})} required data-testid="ce-date" /></div>
          <div><Label>Comments</Label><Input value={form.comments} onChange={e => setForm({...form, comments: e.target.value})} data-testid="ce-comments" /></div>
        </div>
        <Button type="submit" className="bg-[#1f1f1f] text-white" data-testid="ce-submit">Run Closing</Button>
      </form>
      {searched && (
        <div className="bg-white border border-gray-200">
          <table className="w-full">
            <thead><tr className="bg-gray-50 border-b">
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Account</th>
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Type</th>
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Amount</th>
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Status</th>
            </tr></thead>
            <tbody>{results.map((r, i) => (
              <tr key={i} className="border-b">
                <td className="px-4 py-3 text-sm font-medium text-[#1f1f1f]">{r.account}</td>
                <td className="px-4 py-3"><span className={`text-xs px-2 py-1 rounded ${r.type === 'debit' ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>{r.type}</span></td>
                <td className="px-4 py-3 text-sm">R {r.amount?.toLocaleString()}</td>
                <td className="px-4 py-3"><span className="text-xs px-2 py-1 rounded bg-green-50 text-green-700">{r.status}</span></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </AdminSubPage>
  );
};
export default ClosingEntriesPage;
